"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function VotreProjetIci() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="236264" id="start-your-introduction" className="relative py-24 md:py-32 overflow-hidden bg-background text-foreground z-0">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-lg blur-3xl -z-10 pointer-events-none" />
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-secondary/5 rounded-lg blur-3xl -z-10 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent/10 rounded-lg blur-3xl -z-10 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <Card className="relative overflow-hidden border-border shadow-xl bg-card/80 backdrop-blur-sm rounded-md">
            {}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5 pointer-events-none" />
            
            <CardHeader className="text-center pt-12 md:pt-16 pb-6 relative z-10">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <Sparkles className="h-8 w-8" />
              </div>
              <CardTitle className="font-default text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4">
                Ready to maximize your MSP's exit value?
              </CardTitle>
              <CardDescription className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
                Connect with qualified buyers at a fraction of traditional broker fees. 
                Reach out to <span className="text-primary font-semibold hover:text-primary/80 transition-colors">inquiry@buymymsp.com</span> to schedule your 
                introductory call and start your journey today.
              </CardDescription>
            </CardHeader>
            
            <CardContent className="relative z-10">
              {}
            </CardContent>
            
            <CardFooter className="flex justify-center pb-12 md:pb-16 relative z-10">
              <Button size="lg" className="h-14 px-8 text-base group bg-primary text-primary-foreground hover:bg-primary/90 rounded-md transition-all" asChild>
                <Link to="/HomePage">
                  Start Your Introduction
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}